export const match = JSON.parse(`{
    "match": {
        "id": "GN2FGGYS2B1SBPW",
        "homeParticipant": {
            "id": "GN1HA5EQ6XQ88SQ",
            "names": {
                "default": "Ucrania",
                "short": "Ucrania",
                "abbreviation": "UKR",
                "full": "Ucrania"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3095.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3095.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "UKR",
                    "default": "Ucrania"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/2232.png"
                }
            }
        },
        "awayParticipant": {
            "id": "GN1R063FGB6VT6V",
            "names": {
                "default": "República de Macedonia del Norte",
                "abbreviation": "MKD",
                "short": "Macedonia",
                "full": "República de Macedonia del Norte"
            },
            "images": {
                "teamLogo": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/logo/large/3092.png",
                "jersey": "https://images.sports.gracenote.com/images/lib/basic/sport/football/club/shirt_home/large/3092.png"
            },
            "type": "TEAM",
            "typeDetail": "TEAM_NATIONAL",
            "nationality": {
                "names": {
                    "abbreviation": "MKD",
                    "default": "República de Macedonia del Norte"
                },
                "images": {
                    "flag": "https://images.sports.gracenote.com/images/lib/basic/geo/country/flag/medium/4358.png"
                }
            }
        },
        "dateAndTimeInfo": {
            "startDateLocal": "2021-06-17",
            "scheduledStartTimeUTC": "2021-06-17T13:00:00.000Z"
        },
        "status": {
            "resultStatus": "OFFICIAL",
            "scheduleStatus": "COMPLETED"
        },
        "state": {
            "attendance": 10001,
            "awayScorePeriod1": "0",
            "homeFormation": "4-3-3",
            "awayScorePeriod2": "1",
            "homeScore": "2",
            "awayFormation": "5-3-2",
            "winnerParticipantGroup": "HOME",
            "awayScore": "1",
            "homeScorePeriod1": "2",
            "homeScorePeriod2": "0",
            "currentPeriod": "E",
            "neutralGround": "TRUE"
        },
        "venue": {
            "id": "GN83C6B1YR8CSW4",
            "names": {
                "default": "Estadio National Arena"
            }
        },
        "sportId": "GNFB17MNF4TH4KM",
        "matchNumber": 18,
        "relatedSportsEvents": [
            {
                "id": "GN94APGFKZDBVEF",
                "type": "LEAGUE"
            },
            {
                "id": "GN7XWZZJ42FSRFT",
                "type": "LEAGUE_SEASON"
            },
            {
                "id": "GN8N2CJNFGC0M4G",
                "type": "PHASE",
                "typeDetail": "PHASE_ROUND",
                "depth": 1
            },
            {
                "id": "GN6XTMAXA112QVK",
                "type": "PHASE",
                "typeDetail": "PHASE_GROUP",
                "depth": 2,
                "navigationInfo": {
                    "hasStandings": true
                }
            },
            {
                "id": "GN902903YA2SEEB",
                "type": "PHASE",
                "typeDetail": "PHASE_MATCHROUND"
            }
        ]
    }
}`);



// WEBPACK FOOTER //
// ./src/mundial/requests/mockData/match.ts